var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('layout-header',{attrs:{"title":_vm.$route.meta.title || '达州市高新区能源信息大数据平台'}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }